import $ from 'jquery';
import Ajax from '../General/Ajax';

export default class Recaptcha {

    /**
     * Init recaptcha
     */
    constructor() {
        $(() => {
            $('.op-dashboard-settings-recaptcha form').on('submit', this.handleRecaptchaFormSubmit.bind(this));
        });
    }

    /**
     * Form on Settings > Recaptcha submit event handler
     *
     * @param {Object} e
     * @returns {Void}
     */
     handleRecaptchaFormSubmit(e) {
        e.stopPropagation();
        e.preventDefault();

        let $target = $(e.target);
        let secretKey = $target.attr('data-opd-recaptcha-secret-key');
        let siteKey = $target.attr('data-opd-recaptcha-site-key');

        if (siteKey === '' && secretKey === '') {
            window.OPDashboard.Ajax.submitRemoteForm.call(window.OPDashboard.Ajax, e.target);
            $target.attr('data-recaptcha-keys-status', 'invalid');
        } else {
            Promise.all([
                this.verifyRecaptchaSiteKey(siteKey),
                this.verifyRecaptchaSecretKey(secretKey)
            ])
            .then(([isValidSiteKey, isValidSecretKey]) => {
                if (!isValidSiteKey || !isValidSecretKey) {
                    return false;
                }

                if (isValidSiteKey && isValidSiteKey) {
                    window.OPDashboard.Ajax.submitRemoteForm.call(window.OPDashboard.Ajax, e.target);
                    $target.attr('data-recaptcha-keys-status', 'valid');
                    return true;
                }
            })
        }
    }

    /**
     * Google recaptcha site key verification
     *
     * @param {String} siteKey
     * @returns {Boolean}
     */
    async verifyRecaptchaSiteKey(siteKey) {
        var that = this;

        return new Promise(function(resolve, reject) {
            that.loadRecaptchaScript(function() {
                // Validate site key
                if (typeof grecaptcha !== "undefined") {
                    grecaptcha.ready(function () {
                        try {
                            grecaptcha
                                .execute(siteKey, { action: 'op3Action' })
                                .then(function () {
                                    resolve(true);
                                });
                        } catch (error) {
                            window.OPDashboard.Helpers.notify("Invalid Google ReCaptcha v3 Site Key", "error");
                            resolve(false);
                        }
                    });
                }
            })
        });
    }

    /**
     * Google recaptcha secret key verification
     *
     * @param {String} secretKey
     * @returns {Boolean}
     */
    verifyRecaptchaSecretKey(secretKey) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: OpsScriptData.ajax_url,
                method: 'post',
                data: {
                    action: 'opd_receptcha_secret_key',
                    _wpnonce: OpsScriptData.nonce,
                    secret: secretKey,
                    response: '',
                },
                success: function (response) {
                    if (response.success && response.correct)
                        return resolve(true);

                    window.OPDashboard.Helpers.notify("Invalid Google ReCaptcha v3 Secret Key.", "error");

                    return resolve(false);
                },
                error: function (response) {
                    window.OPDashboard.Helpers.notify("Error occurred while trying to validate ReCaptcha secret key.", "error");
                    return false;
                }
            });
        });
    }

    /**
     * Load google recaptch js script asyncronously
     * We are loading recaptcha script because there is no other
     * way to validate site key
     *
     * @returns {Void}
     */
    loadRecaptchaScript(callback) {
        if (window.grecaptcha)
            window.grecaptcha = null;

        window.recaptchaLoaded = function() {
            callback();
        }

        let siteKey = $('input[name="opd_recaptcha_site_key').val();
        let ref = document.getElementsByTagName('script')[0];
        let script = document.createElement('script');
        script.async = true;
        script.src = "https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=" + siteKey;
        ref.parentNode.insertBefore(script, ref);
    }
}
